/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshSavingsApplet} from '../api'

export const useMutationRefreshSavingsApplet = createReactQueryMutationHook('refreshSavingsApplet', refreshSavingsApplet)
